/**
 * Version of the lead-capture system itself (question set + qualification
 * logic + record shape), independent of `EstimatorInput.inputSchemaVersion`
 * (the calculation engine's input contract) and `EstimatorResult.pricingVersion`
 * (the pricing dataset). A `LeadRecord` stamps all three so a later reader
 * can tell which capture form, which pricing catalog, and which input
 * schema produced a given lead, even as each evolves independently.
 *
 * Bump this when the lead capture form's fields, validation rules, or
 * qualification categories change in a way that would matter to someone
 * auditing historical leads.
 */
export const ESTIMATOR_VERSION = "16.0.0";
